export default __webpack_public_path__ + "static/media/tree15.15879a94.png";